<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Row :gutter="12">
        <Col span="24">
          <Tabs :value="currentRoute" @on-click="changeRouter">
            <TabPane name="iosmonitorlist" label="iOS监控规则列表"></TabPane>
            <TabPane v-if="currentRoute === 'iosmonitoradd'" name="iosmonitoradd" :label="`${addName}iOS监控规则`"></TabPane>
          </Tabs>
        </Col>
      </Row>
      <div class="c-content">
        <router-view />
      </div>
    </Content>
  </Layout>
</template>
<script>
export default {
  name: 'monitorule',
  computed: {
    addName() {
      return this.editStat ? '修改' : '新增'
    }
  },
  methods: {
    changeRouter(name) {
      this.$router.push({ name })
    },
    getCurrent() {
      if (this.$route.name === 'iosmonitor') this.changeRouter('iosmonitorlist')
      this.editStat = this.$route.name === 'iosmonitoradd'
      this.currentRoute = this.$route.name
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  data() {
    return {
      editStat: null,
      currentRoute: ''
    }
  },
  created() {
    this.getCurrent()
  }
}
</script>
